export default __webpack_public_path__ + "static/8-haida-gwaii-label-abe1b0e0d275e96b568f7b1885c1cd36.svg";